import type { SessionRepository } from '@/core/session'
import type { UseCase } from '@/core/shared'

export const getAllFilters: UseCase<SessionRepository, 'getAllFilters'> = repository => {
  return async groupUid => {
    const sessions = await repository.getAllFilters(groupUid)
    return sessions
  }
}
